// extracted by mini-css-extract-plugin
module.exports = {"absolute-background":"XeGT6x1c","hero":"gGlJl8C4","title":"haRWeKYV","description":"qE4w0u0q","bghero":"gKuuJHjq"};